// File: app/src/components/workout/ColdWarmupSheet.js
//
// Longer warm-up in the cold (issue #76): the coach's one offer, made during
// the warm-up when the Khronos Timer reads cold. Swiping it away is "Not today".

import React from "react";
import DetailSheet from "../session/generate/DetailSheet";
import { Button } from "../ui/button";

export const ColdWarmupSheet = ({ offer, onAdd, onDecline }) => {
  if (!offer) return null;
  const minutes = Math.round(offer.addSec / 60);
  return (
    <DetailSheet
      open
      onOpenChange={(next) => {
        if (!next) onDecline();
      }}
      title={`It's ${Math.round(offer.tempC)} °C at your timer`}
      description="Muscles take longer to warm up in the cold. A few more easy minutes before the main work makes it safer and feel better."
      showDescription
      footer={
        <div className="grid grid-cols-2 gap-2">
          <Button type="button" variant="outline" className="h-12 text-base" onClick={onDecline}>
            Not today
          </Button>
          <Button type="button" className="h-12 text-base font-semibold" onClick={onAdd}>
            {`Add ${minutes} min`}
          </Button>
        </div>
      }
    >
      <p className="text-base font-semibold leading-snug">{offer.text}</p>
    </DetailSheet>
  );
};
